// extracted by mini-css-extract-plugin
export var bubble = "_2e-0";
export var container = "_2e-f";
export var contrastBorder = "_2e-g";
export var greyOut = "_2e-2";
export var initialsColor0 = "_2e-3";
export var initialsColor1 = "_2e-4";
export var initialsColor10 = "_2e-d";
export var initialsColor11 = "_2e-e";
export var initialsColor2 = "_2e-5";
export var initialsColor3 = "_2e-6";
export var initialsColor4 = "_2e-7";
export var initialsColor5 = "_2e-8";
export var initialsColor6 = "_2e-9";
export var initialsColor7 = "_2e-a";
export var initialsColor8 = "_2e-b";
export var initialsColor9 = "_2e-c";
export var initialsWrapper = "_2e-1";
export var large = "_2e-l";
export var medium = "_2e-k";
export var mediumSmall = "_2e-j";
export var mediumSmallMedium = "_2e-o";
export var micro = "_2e-h";
export var small = "_2e-i";
export var tiny = "_2e-n";
export var xTiny = "_2e-m";